var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"is-small":true}},[_vm._v("ログイン")]),_c('div',{staticClass:"container-fluid error-page"},[_c('icon-error',[_vm._v("アクセスしているログイン画面が間違っている可能性があります。ログイン画面が正しいかご確認をお願いします。")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }